<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>

  <div class="col-10 px-0">
    @if (currentContent === 'queries') {
      <div class="card">
        <h4 class="card-header">Queries</h4>
        <div class="card-body">
          <app-add-rule-form [ngClass]="{ 'disabled': isLoading.rules }"></app-add-rule-form>
          <hr class="mt-0">
          <table class="table table-bordered" [ngClass]="{ 'disabled': isLoading.rules }">
            <thead class="thead-light">
              <tr>
                <!-- <th scope="col">ID</th> -->
                <!-- <th scope="col">Tag</th> -->
                <th scope="col">Name</th>
                <th scope="col" width="50%" class="d-none d-lg-table-cell">Value</th>
                <th scope="col" class="d-none d-lg-table-cell">Characters</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            @if (rules.length === 0) {
              <tbody>
                <tr>
                  <td colspan="4">There are no rules.</td>
                </tr>
              </tbody>
            }
            <tbody>
              @for (rule of rules; track rule) {
                <tr>
                  <!-- <td>{{rule.id}}</td> -->
                  <!-- <td>{{rule.tag}}</td> -->
                  <td>
                    <input class="form-control" [ngClass]="{'is-invalid': !rule.name }"
                      type="text" [(ngModel)]="rule.name" maxlength="100" placeholder="Name">
                  </td>
                  <td class="d-none d-lg-table-cell">
                    <textarea class="form-control" [ngClass]="{'is-invalid': !rule.value }"
                    rows="7" [(ngModel)]="rule.value" maxlength="512" placeholder="Value"></textarea>
                  </td>
                  <td class="d-none d-lg-table-cell">{{rule.value.length}} <small>/ 512</small></td>
                  <td>
                    <button class="btn btn-sm btn-primary" (click)="updateRule(rule)" [disabled]="!rule.value || !rule.name"
                      data-bs-toggle="tooltip" data-placement="top" title="Update">
                      <i class="fa fa-save"></i>
                    </button>
                    <button class="btn btn-sm btn-danger ms-2" (click)="deleteRule(rule)" [disabled]="!rule.value || !rule.name"
                      data-bs-toggle="tooltip" data-placement="top" title="Delete">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    @if (currentContent === 'logs') {
      <div class="card">
        @for (log of logNames; track log) {
          <div>
            <h4 class="card-header">
              {{log.name}}.log <small class="text-muted">{{log.lines}} lines</small>
              <button class="btn btn-primary btn-sm float-end" (click)="getLog(log.name, log.lines)"
                data-bs-toggle="tooltip" data-placement="top" title="Refresh">
                <i class="fa fa-refresh"></i>
              </button>
              <button class="btn btn-danger btn-sm float-end me-1" (click)="clearLog(log.name)"
                data-bs-toggle="tooltip" data-placement="top" title="Clear">
                <i class="fa fa-trash"></i>
              </button>
            </h4>
            <div class="card-body">
              <textarea class="form-control" rows="10" readonly>{{logs[log.name] | async}}</textarea>
            </div>
          </div>
        }
      </div>
    }

    @if (!isLoading.feedback && currentContent === 'feedback') {
      <div class="card">
        <h4 class="card-header">Feedback ({{feedback.length}})</h4>
        <div class="card-body">
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th scope="col" class="d-none d-lg-table-cell">User</th>
                <th scope="col" class="">Feedback</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            @if (feedback.length === 0) {
              <tbody>
                <tr>
                  <td colspan="5">There are no feedback.</td>
                </tr>
              </tbody>
            }
            <tbody>
              @for (f of feedback; track f) {
                <tr>
                  <td class="d-none d-lg-table-cell">{{f._user.firstName}} {{f._user.lastName}}</td>
                  <td class="">{{f.feedback}} <small class="text-muted">{{f.created_at | date:'medium'}}</small></td>
                  <td>
                    <button class="btn btn-sm btn-primary me-1" (click)="updateFeedback(f)"
                      data-bs-toggle="tooltip" data-placement="top" title="Done">
                      <i class="fa fa-check-circle"></i>
                    </button>
                    <button class="btn btn-sm btn-danger" (click)="deleteFeedback(f)"
                      data-bs-toggle="tooltip" data-placement="top" title="Delete">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

  </div>

</div>
